/* eslint-env browser */
import * as React from 'react'
import Smooch from 'smooch'

require('../../container/client')
require('./style.scss')

const ReactDOM = require('react-dom')

const NewSubmissionForm = require('./components/new-submission-form')
const DomHelper = require('../../client/clientjs/dom-helper')

DomHelper.onDocumentReady(() => {
  const renderElt = DomHelper.query('#react-render-new-business-submission-form')
  if (renderElt) {
    ReactDOM.render(<NewSubmissionForm localeShortIdentifier={window.initialState.locale.identifierShort} />, renderElt)
  }

  Smooch.destroy()
  Smooch.init({
    appId: '56da9c0cb27ef129003ddf23',
    customText: window.initialState.smoochCustomText,
  })
})

if (module.hot) {
  module.hot.accept()
}
